import AppFrame from '../components/AppFrame'
import CreateExport from '../components/Exports/CreateExport/CreateExport.jsx'

const CreateExportPage = () => (
    <CreateExport />
)

export default CreateExportPage